/* istanbul ignore file -- @preserve */

import createUploadLink from 'apollo-upload-client/createUploadLink.mjs';
import { bffAPILink } from 'bff';

function buildHttpLink() {
  return createUploadLink({
    uri: bffAPILink,
    credentials: 'include',
    // The API rejects non-JSON GraphQL POSTs (multipart uploads) unless they
    // carry a header that forces a CORS preflight. Sent on every request so
    // uploads from team-less pages (/management, /oem_onboard) still pass.
    headers: { 'X-Requested-With': 'XMLHttpRequest' },
  });
}
export default buildHttpLink;
